import { useMutation } from "@apollo/client";
import { READ_ALL_NOTIFICATION_MUTATION } from "./notification.query";
import {
  ReadAllNotificationsMutation,
  ReadAllNotificationsMutationVariables,
} from "@/__generated__/graphql";
import { Button } from "@/components/ui/button";

const MarkAllAsRead = ({
  unReadCount = 0,
  refetch,
}: {
  unReadCount: number;
  refetch: () => void;
}) => {
  const [ReadAllNotifications] = useMutation<
    ReadAllNotificationsMutation,
    ReadAllNotificationsMutationVariables
  >(READ_ALL_NOTIFICATION_MUTATION);

  return (
    <Button
      onClick={async () => {
        if (unReadCount > 0) {
          await ReadAllNotifications();
          refetch();
        }
      }}
      disabled={unReadCount == 0}
      className="ring-1 rounded-2xl py-0.5 px-3 text-xs text-link font-semibold ring-link cursor-pointer hover:bg-link/20"
    >
      Mark as Read
    </Button>
  );
};

export default MarkAllAsRead;
